<template>
  <div>
    <div class="card-header" @click="$emit('open')">
      <p class="card-header-title">
        <slot name="title">
          Please add title to section.
        </slot>
      </p>
      <a class="card-header-icon">
        <b-icon :icon="open ? 'menu-up' : 'menu-down'" />
      </a>
    </div>
    <div v-if="open" id="open-div" class="slidedown">
      <AudioBar
        v-if="path"
        :path="path"
        :startTime="timeRepresentative"
        @timeRepresentative="updateTimeRepresentative"
      />
      <div class="accordion-content">
        <slot name="content">
          Please add content to the section.
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import AudioBar from "@/components/AudioBar.vue";

export default {
  name: "AccordionSection",
  components: {
    AudioBar
  },
  props: {
    path: {
      type: String
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      timeRepresentative: 0
    };
  },
  methods: {
    updateTimeRepresentative(value) {
      this.timeRepresentative = value;
    }
  }
};
</script>

<style lang="scss" scoped>
.card-header {
  background-color: $maroon;
  position: relative;
  z-index: inherit;
}

.card-header-title {
  color: $white;
}

.card-header-icon {
  color: $white;
}

.accordion-content {
  background-color: #99244c;
  padding: 1rem;
}

.slidedown {
  animation: slidedown 0.5s ease-in forwards;
  position: relative;
  z-index: inherit;
}

@keyframes slidedown {
  0% {
    -webkit-transform: translateY(-50%);
  }
  100% {
    -webkit-transform: translateY(0);
  }
}
</style>
